import React, { useEffect, useRef, useState } from 'react';
import { useAsyncDebounce } from 'react-table';
import { useTableInstance } from '../TableContext/index.js';
import { TableFilter } from './TableFilter.js';
/**
 * Filters the table data locally that matches the string entered in the Search input.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { ConnectedTable, ConnectedTableFilter, TableFilter, TableProvider } from "@panwds/react-table";
 * ```
 */
export const ConnectedTableFilter = ({ placeholder }) => {
    const { autoResetGlobalFilter, data, setGlobalFilter, state: { globalFilter = '' } } = useTableInstance();
    const componentMounted = useRef(false);
    const [value, setLocalValue] = useState(globalFilter);
    const setGlobalValue = useAsyncDebounce((v) => {
        setGlobalFilter(v);
    }, 200);
    useEffect(() => {
        if (!componentMounted.current) {
            componentMounted.current = true;
        }
        else if (autoResetGlobalFilter) {
            setLocalValue('');
            setGlobalFilter('');
        }
    }, [autoResetGlobalFilter, data]);
    return (React.createElement(TableFilter, { onChange: (e) => {
            const v = e.currentTarget.value;
            setLocalValue(v);
            setGlobalValue(v);
        }, placeholder: placeholder, value: value }));
};
//# sourceMappingURL=ConnectedTableFilter.js.map